<template>
  <v-container fluid>
    <v-row>
      <v-col md="6">
        <v-toolbar flat density color="grey lighten-4">
          <v-toolbar-title class="mt-4">Edit Uniform Kit Configuration</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col md="6" class="text-right">
        <router-link :to="{ name: 'listUniformKitMapping' }">
          <v-btn rounded v-if="$vuetify.breakpoint.smAndUp" class="mt-4 black--text" elevation="0">
            <v-icon left>mdi-chevron-left</v-icon>Back
          </v-btn>
          <v-btn v-else fixed right small rounded fab color="grey lighten-4" elevation="2" class="mr-2 mt-4"
            style="opacity: 0.8">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card-component>
          <v-row>
            <v-col cols="12" md="3" sm="4" lg="3">
              <v-autocomplete v-model="productApparelDetails.productTypeID" :items="productApparelTypes"
                item-text="displayName" item-value="id" label="Product Apparel Type" dense hide-details="true" :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  "></v-autocomplete>
            </v-col>

            <v-col cols="12" md="3" sm="4" lg="3">
              <v-text-field v-model="productApparelDetails.productid" hide-details="true" label="Product ID" type="number"
                dense :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  " />
            </v-col>
            <v-col cols="12" md="3" sm="4" lg="3">
              <v-text-field v-model="productApparelDetails.alternateFCID" hide-details="true" label="Alternate Product ID"
                type="number" dense :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  " />
            </v-col>

            <v-col cols="12" md="3" sm="4" lg="3">
              <v-text-field v-model="productApparelDetails.size" hide-details="true" label="Product Size" type="text"
                dense :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  " />
            </v-col>

            <v-col cols="12" md="3" sm="4" lg="3">
              <v-text-field v-model="productApparelDetails.chest" hide-details="true" label="Chest Size" type="text" dense
                :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  " />
            </v-col>

            <v-col cols="12" md="3" sm="4" lg="3">
              <v-text-field v-model="productApparelDetails.frontLength" hide-details="true" label="Front Length"
                type="text" dense :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  " />
            </v-col>

            <v-col cols="12" md="3" sm="4" lg="3">
              <v-text-field v-model="productApparelDetails.shoulderSize" hide-details="true" label="Shoulder Size"
                type="text" dense :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  " />
            </v-col>

            <v-col cols="12" md="3" sm="4" lg="3">
              <v-text-field v-model="productApparelDetails.waistRelax" hide-details="true" label="Waist Relax" type="text"
                dense :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  " />
            </v-col>

            <v-col cols="12" md="3" sm="4" lg="3">
              <v-text-field v-model="productApparelDetails.waistStretch" hide-details="true" label="Waist Stretch"
                type="text" dense :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  " />
            </v-col>

            <v-col cols="12" md="3" sm="4" lg="3">
              <v-text-field v-model="productApparelDetails.length" hide-details="true" label="Length" type="text" dense
                :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  " />
            </v-col>

            <v-col cols="12" md="3" sm="4" lg="3">
              <v-text-field v-model="productApparelDetails.quantity" hide-details="true" label="Quantity" type="number"
                dense :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  " />
            </v-col>

            <v-col cols="12" md="3" sm="4" lg="3">
              <v-text-field v-model="productApparelDetails.productName" hide-details="true" label="Product Name"
                type="text" dense :style="$vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                  " />
            </v-col>
          </v-row><br>
          <v-row justify="center">
            <v-btn class="mr-1" dense color="success" elevation="0" @click="updateProductApparelDetails()">
              save
            </v-btn>
          </v-row>
        </v-card-component>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent.vue'
import constants from '@/utils/constants'
import _ from 'lodash'
export default {
  name: 'editUnifromProductApparel',
  props: ['productApparelID'],
  components: {
    VCardComponent
  },
  data () {
    return {
      kitJsonData: [],
      productApparelTypes: [],
      selectedProductApparelType: null,
      productID: null,
      productApparelDetails: null
    }
  },
  created: async function () {
    // this.getKitData()
    await this.getProductApparelTypes()
    await this.getProductApparelDetails()
  },
  methods: {
    getProductApparelTypes: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/product/apparel-types`
        )
        this.productApparelTypes = _.map(response.data, type => {
          type.displayName = `${type.type} ${type.subType} ${type.gender}`
          return type
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    getProductApparelDetails: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/uniform/get-product-apparel-details/${this.productApparelID}`
        )
        if (response.status === 200) {
          this.selectedProductApparelType = response.data.productTypeID
          this.productApparelDetails = response.data
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },

    updateProductApparelDetails: async function () {
      try {
        if (this.productApparelDetails.productTypeID === '' || this.productApparelDetails.productTypeID === null) {
          return this.errMsg('ProductID should not be empty')
        }
        if (this.productApparelDetails.productid === '' || this.productApparelDetails.productid === null) {
          return this.errMsg('ProductID should not be empty')
        }
        if (this.productApparelDetails.size === '' || this.productApparelDetails.size === null) {
          return this.errMsg('Size should not be empty')
        }
        let payload = {}
        payload.data = this.productApparelDetails
        const response = await http.post(
          `${constants.API_URL}/api/uniform/update-product-apparel-details`, payload
        )
        if (response.status === 200) {
          this.$router.push({ name: 'listUniformKitMapping' })
          this.okMsg('Product Apparel details Updated.')
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
